import { createTypedEnum } from '@reckon-web/formschema-enums';

export const NetworkState = createTypedEnum({
  loading: 'Loading',
  success: 'Success',
  error: 'Error',
});
